var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9793 5.99018C19.7195 5.99792 19.473 6.1065 19.2918 6.29292L8.99886 16.5859L5.70589 13.2929C5.61375 13.1969 5.50338 13.1203 5.38125 13.0675C5.25912 13.0147 5.12769 12.9869 4.99465 12.9855C4.86161 12.9842 4.72964 13.0094 4.60646 13.0597C4.48328 13.1099 4.37138 13.1843 4.2773 13.2784C4.18322 13.3725 4.10886 13.4844 4.05857 13.6075C4.00828 13.7307 3.98307 13.8627 3.98443 13.9957C3.98578 14.1288 4.01367 14.2602 4.06645 14.3823C4.11924 14.5045 4.19586 14.6148 4.29183 14.707L8.29183 18.707C8.47938 18.8944 8.73369 18.9998 8.99886 18.9998C9.26404 18.9998 9.51835 18.8944 9.70589 18.707L20.7059 7.70698C20.8504 7.56652 20.9491 7.38567 20.9891 7.18815C21.029 6.99063 21.0084 6.78565 20.9298 6.60007C20.8513 6.41448 20.7185 6.25695 20.5489 6.14812C20.3793 6.03929 20.1808 5.98424 19.9793 5.99018Z",
    fill: "#00624F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.1a25f1e3730a6cd19f2989c86623c1e1.svg";
export { ForwardRef as ReactComponent };